<!--
 * @message: 颜色输入组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-07 17:14:05
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_selectDepartments.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-07 14:08:54
-->
<template>
  <div class="d-flex justify-start flex-column">
    <v-sheet
      v-if="showLabel"
      class="text--secondary pl-1 d-inline-block text-truncate transparent"
    >
      <span :class="labelClass"> {{ $t(label) }} </span>
    </v-sheet>
    <v-combobox
      v-model="curValue"
      :items="[]"
      ref="selectdep"
      :disabled="disabled"
      item-color="transparent"
      :multiple="multiple"
      height="40"
      :readonly="readonly"
      :rules="readonly ? [] : rules"
      :filled="filled"
      dense
      :placeholder="placeholder"
      hide-details
      :allow-overflow="false"
      @update:search-input="
        (e) => {
          search = e;
        }
      "
      @update:list-index="
        () => {
          return;
        }
      "
      :append-icon="readonly ? '' : appendIcon"
      :single-line="singleLine"
    >
      <template v-slot:selection="data" v-if="curValue.length > 0">
        <v-chip
          v-bind="data.attrs"
          close
          small
          class="mx-1 my-1"
          :input-value="data.selected"
          v-if="data.index < $selectSetting.maxChips"
          @click="data.select"
          @click:close="curValue.splice(data.index, 1)"
        >
          {{ $getCommonLangValue(curValue[data.index]["org_level_name"]) }}
        </v-chip>
        <v-hover
          v-slot="{ hover }"
          v-if="data.index === $selectSetting.maxChips"
        >
          <span
            :class="hover ? 'rounded primary--text' : 'text--secondary'"
            @click.stop="
              () => {
                $emit('view-select');
                if ($refs.selectdep) {
                  $refs.selectdep.blur();
                }
              }
            "
            class="py-2"
          >
            ...{{ curValue.length - $selectSetting.maxChips
            }}{{ $t("label_essweb_selection_moreItemLabel") }}
          </span>
        </v-hover>
      </template>
      <template v-slot:no-data>
        <noContent v-if="items.length == 0" />
        <v-treeview
          selectable
          v-else
          open-all
          open-on-click
          :search="search"
          selected-color="primary"
          :items="items"
          item-key="uuid"
          v-model="curValue"
          :filter="filter"
          return-object
          item-text="org_level_name"
          item-children="items"
        >
          <template v-slot:label="{ item }">
            <span
              class="text--secondary"
              v-html="hightLightKeyword(item.org_level_name, search)"
            ></span>
          </template>
        </v-treeview>
      </template>
    </v-combobox>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Mrc_department_input",
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "pageTriger"]),
    labelClass() {
      let cla = " ";
      if (this.isRequire) {
        cla += " mrc_text_require";
      }
      if (this.showMenu) {
        cla += " primary--text";
      } else {
        cla += " text--secondary";
      }
      return cla;
    },
    filter() {
      return (item, search, textKey) =>
        this.$getCommonLangValue(item[textKey]).indexOf(search) > -1;
    },
  },
  props: {
    //规则
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    value: { default: [], type: [String, Number, Array, Object] },
    items: {
      default: function () {
        return [];
      },
      type: [String, Array],
    },
    isRequire: { default: false, type: Boolean },
    placeholder: { default: "", type: [String, Array] },
    messages: { default: "", type: [String, Array] },
    errorCount: { default: 1, type: Number },
    label: { default: "", type: String },
    itemText: { default: "text", type: String },
    itemValue: { default: "color", type: String },
    showLabel: { default: false, type: Boolean },
    hint: { default: "", type: String },
    singleLine: { default: true, type: Boolean },
    filled: { default: true, type: Boolean },
    persistentHint: { default: false, type: Boolean },
    hideDetails: { default: true, type: Boolean },
    canscroll: { default: true, type: Boolean },
    error: { default: false, type: Boolean },
    disabled: { default: false, type: Boolean },
    success: { default: false, type: Boolean },
    loading: { default: false, type: Boolean },
    clearable: { default: false, type: Boolean },
    maxlength: { default: 150, type: [String, Number, Array, Object] },
    flat: { default: false, type: Boolean },
    dense: { default: true, type: Boolean },
    successMsg: { default: "", type: String },
    appendIcon: {
      default: "arrow_drop_down",
      type: [String, Object, Array, Number],
    },
    appendExpandIcon: {
      default: "arrow_drop_up",
      type: [String, Object, Array, Number],
    },
    height: { default: undefined, type: [String, Number] },
    readonly: { default: false, type: Boolean },
    multiple: { default: false, type: Boolean },
  },
  data() {
    return {
      showMenu: false,
      curValue: [],
      canFocus: false,
      errorMsg: "",
      search: "",
    };
  },
  destroyed() {
    document.onkeydown = undefined; //解绑
  },
  watch: {
    value(val) {
      this.curValue = val;
    },
    curValue(val) {
      this.$emit("change", val);
    },
    pageTriger(val) {
      if (val) this.canFocus = true;
    },
  },
  mounted() {
    this.canFocus = false;
  },
  methods: {
    onFocus: function () {
      this.canFocus = true;
    },
    hightLightKeyword(val, keyword) {
      val = this.$getCommonLangValue(val);
      if (val.indexOf(keyword) !== -1) {
        return val.replace(
          keyword,
          `<font style='background-color:rgba(0,0,0,0.12)'>${keyword}</font>`
        );
      } else {
        return val;
      }
    },
  },
};
</script>

